/* Video use-case pages V4. Holds no customer-visible English: every string comes from the #vu4-data block in the page body. */
(function () {
  'use strict';
  var root = document.getElementById('vu4-root');
  var dataEl = document.getElementById('vu4-data');
  if (!root || !dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var UI = D.ui || {};
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var ds = root.dataset;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var prefix = ds.root || '';
  var fmt = function (s, m) { return String(s == null ? '' : s).replace(/\{(\w+)\}/g, function (x, k) { return k in m ? m[k] : x; }); };
  var emit = function (name, detail) { try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {} };
  root.classList.add('vu4-js');

  /* ---------- money ---------- */
  var locale = (ds.lang && ds.lang !== 'en') ? ds.lang : ({ au: 'en-AU', uk: 'en-GB', eu: 'en-IE' }[ds.region] || 'en');
  var cur = ds.currency || 'GBP';
  /* The store formats every price its own way (for example 3.295 € in all languages). Read that shape from the first rendered price (at call time) so
     amounts built here (calculators, plans) match it; fall back to Intl when the shape cannot be read. */
  var readShape = function () {
    var e = $('.vu4-price'); var t = e ? e.textContent.replace(/\u202f/g, '\u00a0') : '';
    var m = /^(\D*?)(\d{1,3}(?:[^\d]\d{3})*(?:[^\d]\d{2})?|\d+)(\D*)$/.exec(t.trim());
    if (!m) return null;
    var num = m[2], g = /^(\d{1,3})(?:(\D)\d{3})+(?:(\D)\d{2})?$/.exec(num), th = '', dec = '';
    if (g) { th = g[2]; dec = g[3] || ''; }
    else { var d2 = /^\d+(\D)\d{2}$/.exec(num); if (d2) dec = d2[1]; else if (/^\d{1,3}\D\d{3}$/.test(num) && ds.price && parseInt(num.replace(/\D/g, ''), 10) * 100 === parseInt(ds.price, 10)) th = num.charAt(num.length - 4); }
    if (g && !dec && /^\d{1,3}\D\d{2}$/.test(num)) dec = '';
    var pre = t.trim().slice(0, t.trim().indexOf(num)), post = t.trim().slice(t.trim().indexOf(num) + num.length);
    return { pre: pre, post: post, th: th, dec: dec || (th === ',' ? '.' : ',') };
  };
  var money = function (amount, digits) {
    var whole = Math.abs(amount - Math.round(amount)) < 0.005;
    var d = digits == null ? (whole ? 0 : 2) : digits;
    var shape = readShape(); /* read at call time: the store's VAT script rewrites the hero price into the page language after load */
    if (shape) {
      var n = Math.abs(amount).toFixed(d).split('.'), ip = shape.th ? n[0].replace(/\B(?=(\d{3})+(?!\d))/g, shape.th) : n[0];
      return (amount < 0 ? '-' : '') + shape.pre + ip + (d ? shape.dec + n[1] : '') + shape.post;
    }
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency: cur, minimumFractionDigits: d, maximumFractionDigits: d }).format(amount); }
    catch (e) { return amount.toFixed(d) + ' ' + cur; }
  };
  var priceCents = parseInt(ds.price, 10) || 0;
  var excl = root.classList.contains('vu4--excl');
  var euVat = excl && ds.region === 'eu';

  /* ---------- EU VAT basis: labels follow the store's Excl/Incl choice (vat-display.js owns the amounts) ---------- */
  var vatLabels = function () { return $$('[data-vu4-vat]'); };
  var syncVat = function () {
    var v = window.SPXVat, on = !!(v && v.available && v.enabled);
    vatLabels().forEach(function (l) {
      if (l.getAttribute('data-excl') == null) l.setAttribute('data-excl', l.textContent);
      var t = on ? l.getAttribute('data-incl') : l.getAttribute('data-excl');
      if (l.textContent !== t) l.textContent = t;
    });
    root.classList.toggle('vu4--vat-incl', on);
  };
  if (euVat) {
    /* The store script writes two decimals (EUR 3,954.00): show whole amounts without the trailing zeros. */
    var trimVat = function () { $$('[data-vat-cents]').forEach(function (e) { var t = e.textContent, n = t.replace(/([.,])00(?!\d)/, ''); if (n !== t) e.textContent = n; }); };
    var afterVat = function () { syncVat(); setTimeout(trimVat, 0); setTimeout(trimVat, 400); };
    document.addEventListener('spx:vat:ready', afterVat);
    document.addEventListener('spx:vat:change', afterVat);
    window.addEventListener('load', afterVat);
    syncVat();
  }
  /* A sentence that holds the Core price: {amount} becomes its own element so the store script can rewrite it alone. */
  var priceSentence = function (host, tpl, map) {
    var parts = String(tpl).split('{amount}');
    host.textContent = '';
    host.appendChild(document.createTextNode(fmt(parts[0], map)));
    if (parts.length > 1) {
      var sp = document.createElement('span');
      sp.textContent = money(priceCents / 100, 0);
      if (euVat) sp.setAttribute('data-vat-cents', String(priceCents));
      host.appendChild(sp);
      if (excl) {
        var l = document.createElement('span'); l.className = 'vu4-vat'; l.setAttribute('data-vu4-vat', ''); l.setAttribute('data-incl', UI.vatIncl); l.textContent = UI.vat;
        host.appendChild(l);
      }
      host.appendChild(document.createTextNode(fmt(parts[1], map)));
    }
    if (euVat) syncVat();
  };

  /* ---------- internal links keep the visitor's locale ---------- */
  if (prefix) {
    $$('a[href^="/"]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (h.indexOf('//') !== 0 && h.indexOf(prefix + '/') !== 0) a.setAttribute('href', prefix + h);
    });
  }

  /* ---------- value-calc dataset ---------- */
  var bvc = null, cfg = null;
  try {
    var bEl = $('[data-bvc-data]');
    if (bEl) { bvc = JSON.parse(bEl.textContent); cfg = bvc.regions && bvc.regions[bvc.region]; }
  } catch (e) { bvc = null; cfg = null; }
  var toEur = function (c) { if (c === 'EUR') return 1; return bvc && bvc.fx_to_eur && bvc.fx_to_eur[c] ? bvc.fx_to_eur[c] : null; };
  var conv = function (amount, from) {
    if (!from || from === cur) return amount;
    var a = toEur(from), b = toEur(cur);
    return a && b ? amount * a / b : amount;
  };

  /* ---------- dispatch line from the product page's own pre-order box ---------- */
  var dispatch = '', dispatchPre = false;
  (function () {
    var st = $('[data-vu4-form] .bmp-line .bmp-state');
    if (st && !/bmp-state--none/.test(st.className)) {
      dispatch = (st.textContent || '').replace(/\s+/g, ' ').trim();
      dispatchPre = /bmp-state--pre/.test(st.className);
    }
  })();
  var micro = $('[data-vu4-micro]');
  if (micro && dispatch) { micro.textContent = dispatch; if (dispatchPre) micro.classList.add('is-pre'); }
  var closeH = $('#vu4-s9h');
  if (closeH && closeH.getAttribute('data-now') && dispatch && !dispatchPre) closeH.textContent = closeH.getAttribute('data-now');

  /* ---------- tokens that need runtime data ---------- */
  var ptCfg = (function () {
    if (!cfg || !D.ptLine || !cfg.pt_session) return null;
    var labels = (cfg.sources || []).filter(function (s) { return s.field === 'pt_session' && s.label; }).map(function (s) { return s.label; });
    if (!labels.length) return null;
    var pt = conv(cfg.pt_session, cfg.currency);
    var n = Math.floor(priceCents / 100 / pt);
    if (!(n > 0)) return null;
    return { n: n, pt: money(pt, 0), source: labels.join(' ') };
  })();
  var tokenMap = {
    dispatch: dispatch.replace(/[.\s]+$/, ''),
    ptN: ptCfg ? String(ptCfg.n) : '', pt: ptCfg ? ptCfg.pt : '', ptSource: ptCfg ? ptCfg.source.replace(/ /g, ' and ') : '',
  };
  (function fill() {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n, nodes = [];
    while ((n = w.nextNode())) {
      if (n.parentNode && /^(SCRIPT|STYLE)$/.test(n.parentNode.nodeName)) continue;
      if (n.nodeValue.indexOf('{') !== -1) nodes.push(n);
    }
    nodes.forEach(function (t) { t.nodeValue = fmt(t.nodeValue, tokenMap).replace(/\s{2,}/g, ' ').trim(); });
  })();
  $$('[data-need="dispatch"]').forEach(function (el) { if (!dispatch) el.parentNode.removeChild(el); });
  $$('[data-vu4-ptl]').forEach(function (el) { if (!ptCfg) el.parentNode.removeChild(el); });
  var ptEl = $('[data-vu4-ptline]');
  if (ptEl) {
    if (ptCfg) {
      ptEl.textContent = fmt(D.ptLine, { ptN: String(ptCfg.n), pt: ptCfg.pt }) + ' ';
      var sm = document.createElement('small');
      sm.textContent = fmt(D.ptDisclosure, { ptSource: tokenMap.ptSource });
      ptEl.appendChild(sm);
      ptEl.hidden = false;
    }
  }

  /* ---------- hero video, captions, story switching ---------- */
  var video = $('[data-vu4-video]'), cap = $('[data-vu4-cap]'), soundBtn = $('[data-vu4-sound]'), playBtn = $('[data-vu4-play]');
  var cueCap = null;
  if (cap && video) {
    cueCap = document.createElement('p');
    cueCap.className = 'vu4-cap vu4-transcript';
    cueCap.hidden = true;
    cap.parentNode.insertBefore(cueCap, cap.nextSibling);
  }
  var story = D.stories[D.defaultStory], storyId = D.defaultStory, soundOn = false, cueTrackUrl = null;
  var vtt = function (cues) {
    var t = function (s) { var h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), x = (s % 60).toFixed(3); return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (x < 10 ? '0' : '') + x; };
    return 'WEBVTT\n\n' + cues.map(function (c, i) { return (i + 1) + '\n' + t(c[0]) + ' --> ' + t(c[1]) + '\n' + c[2] + '\n'; }).join('\n');
  };
  function setTrack() {
    if (!video || !story.cues) return;
    $$('track', video).forEach(function (t) { t.parentNode.removeChild(t); });
    if (cueTrackUrl) URL.revokeObjectURL(cueTrackUrl);
    try {
      cueTrackUrl = URL.createObjectURL(new Blob([vtt(story.cues)], { type: 'text/vtt' }));
      var tr = document.createElement('track');
      tr.kind = 'captions'; tr.srclang = (ds.lang || 'en').slice(0, 2); tr.label = tr.srclang; tr.src = cueTrackUrl;
      video.appendChild(tr);
      if (tr.track) tr.track.mode = 'hidden';
    } catch (e) {}
  }
  function showCue() {
    if (!soundOn || !cueCap || !story.cues) return;
    var t = video.currentTime, line = '';
    for (var i = 0; i < story.cues.length; i++) { var c = story.cues[i]; if (t >= c[0] && t < c[1]) { line = c[2]; break; } }
    cueCap.hidden = false;
    cueCap.classList.add('is-cue');
    cueCap.textContent = line || ' ';
  }
  function setSound(on) {
    soundOn = on;
    if (!video) return;
    soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    soundBtn.setAttribute('aria-label', on ? UI.soundOff : UI.soundOn);
    if (on) {
      video.muted = false; video.currentTime = 0;
      var p = video.play();
      if (p && p.catch) p.catch(function () { video.muted = true; setSound(false); });
      showCue();
    } else {
      video.muted = true;
      if (cueCap) cueCap.hidden = true;
    }
  }
  if (video) {
    video.addEventListener('timeupdate', showCue);
    video.addEventListener('error', function () { if (cueCap) { cueCap.classList.remove('is-cue'); cueCap.textContent = UI.videoError; cueCap.hidden = false; } });
    if (soundBtn) soundBtn.addEventListener('click', function () { setSound(!soundOn); });
    if (reduce) {
      video.removeAttribute('autoplay'); video.pause();
      if (playBtn) {
        playBtn.hidden = false;
        playBtn.addEventListener('click', function () { video.muted = true; video.play(); playBtn.hidden = true; });
      }
    } else {
      var pp = video.play(); if (pp && pp.catch) pp.catch(function () { if (playBtn) playBtn.hidden = false; });
      if (playBtn) playBtn.addEventListener('click', function () { video.muted = true; video.play(); playBtn.hidden = true; });
    }
    setTrack();
  }
  function applyStory(id, user) {
    var s = D.stories[id]; if (!s) return;
    story = s; storyId = id;
    $$('[data-vu4-h1]').forEach(function (e) { e.textContent = s.h1; if (s.long) e.setAttribute('data-len', 'long'); else e.removeAttribute('data-len'); });
    $$('[data-vu4-sub]').forEach(function (e) { e.textContent = s.sub; });
    $$('[data-vu4-s2h]').forEach(function (e) { e.textContent = s.s2h2; });
    var q = $('[data-vu4-quote]'); if (q) q.textContent = s.quote ? (UI.qOpen || '“') + s.quote + (UI.qClose || '”') : '';
    var qb = $('[data-vu4-quoteblock]'); if (qb) qb.hidden = !s.quote;
    var at = $('[data-vu4-attr]'); if (at) { at.textContent = s.attribution; if (UI.translated && s.quote) { var tr = document.createElement('small'); tr.className = 'vu4-trl'; tr.textContent = UI.translated; at.appendChild(tr); } }
    var bl = $('[data-vu4-beats]'); if (bl) { bl.textContent = ''; s.beats.forEach(function (b) { var li = document.createElement('li'); li.textContent = b; bl.appendChild(li); }); }
    if (video) {
      soundOn = false; soundBtn.setAttribute('aria-pressed', 'false'); soundBtn.setAttribute('aria-label', UI.soundOn);
      video.muted = true; video.poster = s.poster; video.src = s.video; video.style.objectPosition = '50% ' + s.focus + '%';
      video.setAttribute('aria-label', s.caption);
      if (!reduce) { var p2 = video.play(); if (p2 && p2.catch) p2.catch(function () {}); }
      setTrack();
    }
    cap.classList.remove('is-cue'); cap.textContent = s.caption;
    if (cueCap) { cueCap.hidden = true; cueCap.textContent = ''; }
    $$('[data-vu4-story]').forEach(function (b) { if (b.getAttribute('data-vu4-story') === id) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    if (user) {
      try { var u = new URL(location.href); u.searchParams.set('story', id); history.replaceState(null, '', u.toString()); } catch (e) {}
      var hero = $('#vu4-hero'); if (hero) hero.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
  }
  $$('[data-vu4-story]').forEach(function (b) { b.addEventListener('click', function () { applyStory(b.getAttribute('data-vu4-story'), true); }); });
  try { var want = new URLSearchParams(location.search).get('story'); if (want && D.stories[want] && want !== D.defaultStory) applyStory(want, false); } catch (e) {}

  /* ---------- add to cart ---------- */
  var form = $('[data-vu4-form]');
  var productHref = function () { return (ds.productUrl || '/') + (ds.variant ? '?variant=' + ds.variant : ''); };
  var unavailable = root.classList.contains('vu4--na');
  var indirect = root.classList.contains('vu4--indirect') || !ds.variant || !form;
  $$('[data-vu4-atc]').forEach(function (b) {
    b.setAttribute('data-label', b.textContent);
    if (unavailable) { b.textContent = UI.seePackagesBtn; }
  });
  function waitForCare(timeout) {
    var end = Date.now() + timeout;
    return new Promise(function (resolve) {
      (function poll() {
        fetch((ds.cartJs || '/cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var have = (c.items || []).some(function (i) { return String(i.variant_id) === String(ds.careVariant); });
            if (have || Date.now() > end) resolve(have); else setTimeout(poll, 400);
          })
          .catch(function () { resolve(false); });
      })();
    });
  }
  function atc(btn) {
    var where = (btn.closest('section') || btn.closest('.vu4-sticky') || {}).id || 'vu4';
    emit('vu4:atc_click', { location: where, variant: ds.variant });
    if (unavailable || indirect) { location.href = productHref(); return; }
    var all = $$('[data-vu4-atc]'), errs = $$('[data-vu4-err]');
    errs.forEach(function (e) { e.hidden = true; });
    all.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    var label = btn.textContent; btn.textContent = UI.adding;
    var fd = new FormData(form);
    fd.set('quantity', '1');
    fetch(ds.cartAdd || '/cart/add', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json().catch(function () { return {}; }); })
      .then(function () { return waitForCare(4500); })
      .then(function (care) {
        emit('vu4:atc_success', { location: where, variant: ds.variant, care: care });
        location.href = ds.cartUrl || '/cart';
      })
      .catch(function (e) {
        all.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
        btn.textContent = label;
        var host = btn.closest('section,.vu4-sticky') || root;
        var err = $('[data-vu4-err]', host) || errs[0];
        if (err) { err.hidden = false; err.textContent = UI.atcError + ' '; var a = document.createElement('a'); a.href = productHref(); a.textContent = UI.seePackagesBtn; a.className = 'vu4-link'; err.appendChild(a); }
        emit('vu4:atc_error', { location: where, message: String(e && e.message) });
      });
  }
  $$('[data-vu4-atc]').forEach(function (b) { b.addEventListener('click', function () { atc(b); }); });

  /* ---------- sticky bar ---------- */
  var sticky = $('[data-vu4-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    var heroBtn = $('#vu4-hero [data-vu4-atc]'), closeBtn = $('#vu4-close [data-vu4-atc]');
    var heroSeen = true, closeSeen = false, shown = false, hideT = null;
    var measure = function () { var h = sticky.offsetHeight; if (h) root.style.setProperty('--vu4-bar-h', h + 'px'); document.documentElement.style.setProperty('--vu4-bar-h', (h || 64) + 'px'); };
    var update = function () {
      var want = !heroSeen && !closeSeen;
      if (want === shown) return;
      shown = want;
      var btn = $('button', sticky);
      if (want) {
        clearTimeout(hideT); sticky.hidden = false; sticky.removeAttribute('aria-hidden'); measure();
        void sticky.offsetWidth; sticky.classList.add('is-on'); document.body.classList.add('vu4-sticky-on'); if (btn) btn.tabIndex = 0;
      } else {
        sticky.classList.remove('is-on'); document.body.classList.remove('vu4-sticky-on'); sticky.setAttribute('aria-hidden', 'true'); if (btn) btn.tabIndex = -1;
        hideT = setTimeout(function () { if (!shown) sticky.hidden = true; }, 240);
      }
    };
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.target === heroBtn) heroSeen = e.isIntersecting; if (e.target === closeBtn) closeSeen = e.isIntersecting; });
      update();
    }, { threshold: 0.01 });
    if (heroBtn) io.observe(heroBtn);
    if (closeBtn) io.observe(closeBtn);
    window.addEventListener('resize', function () { if (shown) measure(); });
  }

  /* ---------- tabs ---------- */
  $$('[data-vu4-tabs]').forEach(function (wrap) {
    var tabs = $$('[role="tab"]', wrap);
    var select = function (t, focus) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
      if (focus) t.focus();
      var sc = t.parentNode; if (sc && sc.scrollWidth > sc.clientWidth) t.scrollIntoView({ inline: 'nearest', block: 'nearest' });
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = -1;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = (i + 1) % tabs.length;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') n = (i + tabs.length - 1) % tabs.length;
        else if (k === 'Home') n = 0; else if (k === 'End') n = tabs.length - 1;
        if (n >= 0) { e.preventDefault(); select(tabs[n], true); }
      });
    });
  });

  /* ---------- T1 fold toggle ---------- */
  $$('[data-vu4-t1]').forEach(function (t1) {
    $$('[data-vu4-t1b]', t1).forEach(function (b) {
      b.addEventListener('click', function () {
        var st = b.getAttribute('data-vu4-t1b');
        t1.setAttribute('data-state', st);
        $$('[data-vu4-t1b]', t1).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $$('[data-vu4-t1r]', t1).forEach(function (r) { r.hidden = r.getAttribute('data-vu4-t1r') !== st; });
      });
    });
  });

  /* ---------- M3 column ---------- */
  $$('[data-vu4-col]').forEach(function (col) {
    var range = $('.vu4-range', col), read = $('[data-vu4-colread]', col), m3 = D.m3 || {};
    var set = function () {
      var n = parseInt(range.value, 10);
      $$('.vu4-mk', col).forEach(function (m) { m.classList.toggle('is-on', parseInt(m.getAttribute('data-i'), 10) === n); });
      var txt = n === 0 ? m3.bottom : fmt(m3.position, { n: String(n) });
      read.textContent = txt; range.setAttribute('aria-valuetext', txt);
    };
    range.addEventListener('input', set); set();
  });

  /* ---------- T5 mode chart ---------- */
  var curveY = function (mode, x) {
    if (mode === 'eccentric') { var s = Math.min(1, Math.max(0, (x - 0.47) / 0.06)); return 0.4 + 0.4 * (s * s * (3 - 2 * s)); }
    if (mode === 'chain') return x < 0.5 ? 0.25 + 0.6 * (x / 0.5) : 0.85 - 0.6 * ((x - 0.5) / 0.5);
    return 0.5;
  };
  var curvePath = function (mode) {
    var d = '', N = 60;
    for (var i = 0; i <= N; i++) { var x = i / N, px = 36 + 294 * x, py = 150 - 136 * curveY(mode, x); d += (i ? ' L' : 'M') + px.toFixed(1) + ' ' + py.toFixed(1); }
    return d;
  };
  $$('[data-vu4-t5]').forEach(function (t5) {
    var path = $('.vu4-curve', t5), def = $('.vu4-t5-def', t5), tag = $('.vu4-ct--tag', t5), svg = $('.vu4-chart', t5), modes = D.modes;
    var cur = t5.getAttribute('data-default') || 'standard', raf = 0;
    var pts = function (mode) { var a = []; for (var i = 0; i <= 60; i++) a.push(curveY(mode, i / 60)); return a; };
    var from = pts(cur);
    var draw = function (a) { var d = ''; for (var i = 0; i <= 60; i++) { d += (i ? ' L' : 'M') + (36 + 294 * i / 60).toFixed(1) + ' ' + (150 - 136 * a[i]).toFixed(1); } path.setAttribute('d', d); };
    var show = function (mode, animate) {
      cancelAnimationFrame(raf);
      var to = pts(mode);
      path.style.strokeDasharray = mode === 'fixed' ? '8 6' : '';
      tag.hidden = mode !== 'fixed';
      def.textContent = modes[mode].def;
      svg.setAttribute('aria-label', modes[mode].name + '. ' + modes[mode].def);
      $$('[data-mode]', t5).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mode') === mode ? 'true' : 'false'); });
      $$('[data-mode-def]', t5).forEach(function (li) { li.classList.toggle('is-on', li.getAttribute('data-mode-def') === mode); });
      if (!animate || reduce) { draw(to); from = to; cur = mode; return; }
      var t0 = performance.now(), a0 = from.slice();
      (function step(now) {
        var k = Math.min(1, (now - t0) / 300), e = 1 - Math.pow(1 - k, 3), a = a0.map(function (v, i) { return v + (to[i] - v) * e; });
        draw(a);
        if (k < 1) raf = requestAnimationFrame(step); else { from = to; }
      })(t0);
      cur = mode;
    };
    $$('[data-mode]', t5).forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-mode'), true); }); });
    show(cur, false);
  });

  /* ---------- generic radio group ---------- */
  function radios(group, onChange) {
    var items = $$('[role="radio"]', group);
    var pick = function (el, focus) {
      items.forEach(function (x) { var on = x === el; x.setAttribute('aria-checked', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; });
      if (focus) el.focus();
      onChange(el.getAttribute('data-v'));
    };
    items.forEach(function (el, i) {
      el.addEventListener('click', function () { pick(el, false); });
      el.addEventListener('keydown', function (e) {
        var n = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % items.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i + items.length - 1) % items.length;
        if (n >= 0) { e.preventDefault(); pick(items[n], true); }
      });
    });
  }

  /* ---------- T3 calculator ---------- */
  $$('[data-vu4-t3]').forEach(function (el) {
    if (!cfg) { var tool = el.closest('section'); if (tool) tool.hidden = true; return; }
    var T = D.t3, st = JSON.parse(el.getAttribute('data-d'));
    var out = function (k) { return $('[data-out="' + k + '"]', el); };
    var vat = excl && cfg.vat_rate ? 1 + cfg.vat_rate / 100 : 1;
    $$('[data-vu4-gympr]', el).forEach(function (s) {
      var v = conv(cfg.gym_month[s.getAttribute('data-vu4-gympr')], cfg.currency);
      s.textContent = fmt(T.gym.month, { amount: money(v) });
    });
    var yearsLabel = function (y) { return y === 1 ? T.years.one : fmt(T.years.many, { n: String(y) }); };
    var compute = function () {
      var people = +st.people, wk = +st.workouts, trav = +st.travel, yrs = +st.years;
      var gymMonth = conv(cfg.gym_month[st.gym], cfg.currency);
      var visits = people * wk * 48 * yrs;
      var minSaved = trav * 2 + 10 - 5;
      var hours = people * wk * 48 * minSaved / 60;
      var fees = people * gymMonth * 12 * yrs;
      var price = priceCents / 100 * vat;
      var hoursTotal = Math.round(hours * yrs);
      var yl = yearsLabel(yrs);
      out('timeVal').textContent = fmt(T.tiles.timeVal, { h: Math.round(hours).toLocaleString(locale) });
      out('fees').textContent = money(fees, 0);
      out('feesLabel').textContent = fmt(T.tiles.fees, { years: yl });
      out('perGm3Label').textContent = T.tiles.perGm3;
      out('perGm3').textContent = money(price / visits, 2);
      out('perGymLabel').textContent = T.tiles.perGym;
      out('perGym').textContent = money(fees / visits, 2);
      var diff = Math.abs(fees - price);
      out('result').textContent = fees > price
        ? fmt(T.more, { years: yl, difference: money(diff, 0), hoursTotal: hoursTotal.toLocaleString(locale) })
        : fmt(T.less, { years: yl, difference: money(diff, 0), hoursTotal: hoursTotal.toLocaleString(locale) });
      var srcLabels = {}, srcList = [];
      (cfg.sources || []).forEach(function (s) { if (s.label && !srcLabels[s.label]) { srcLabels[s.label] = 1; srcList.push(s.label); } });
      var srcText = srcList.length ? srcList.join(', ') : T.estimate;
      var shown = money(price, 0) + (vat !== 1 ? ' ' + T.inclVat : '');
      var lines = [
        fmt(T.lineVisits, { people: people, workouts: wk, years: yrs, visits: visits.toLocaleString(locale) }),
        fmt(T.lineMinutes, { travel: trav, min: minSaved }),
        fmt(T.lineHours, { people: people, workouts: wk, min: minSaved, hours: Math.round(hours).toLocaleString(locale) }),
        fmt(T.lineFees, { people: people, month: money(gymMonth), years: yrs, fees: money(fees, 0) }),
        fmt(T.linePrice, { amount: money(price, 0) + (vat !== 1 ? ' ' + T.inclVat : '') }),
        fmt(T.lineSource, { asOf: bvc.as_of, sources: srcText }),
      ];
      var ul = out('calc'); ul.textContent = '';
      lines.forEach(function (t) { var li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
      out('sum').textContent = fmt(T.beside, { hours: Math.round(hours).toLocaleString(locale), amount: shown });
    };
    $$('[data-vu4-ctl]', el).forEach(function (g) {
      var id = g.getAttribute('data-vu4-ctl');
      radios(g, function (v) { st[id] = v; compute(); });
    });
    compute();
  });

  /* ---------- T2 room planner ---------- */
  $$('[data-vu4-t2]').forEach(function (el) {
    var T = D.t2, def = JSON.parse(el.getAttribute('data-def'));
    var S = { unit: 'cm', state: 'use', w: def.w, l: def.l, c: null, x: 20, y: 20 };
    var MW = { use: 122, fold: 37 }, MH = 69, CEIL = 185, CEIL_MIN = 150, CEIL_MAX = 500;
    var plan = $('[data-vu4-plan]', el);
    var NS = 'http://www.w3.org/2000/svg';
    var cmToFt = function (cm) { var i = Math.round(cm / 2.54); return { ft: Math.floor(i / 12), inch: i % 12 }; };
    var rangeTxt = function (v) { if (S.unit === 'cm') return v + ' ' + UI.cm; var f = cmToFt(v); return f.ft + ' ' + UI.ftLabel + ' ' + f.inch + ' ' + UI.inLabel; };
    var dims = {};
    $$('[data-dim]', el).forEach(function (d) {
      var id = d.getAttribute('data-dim');
      dims[id] = { box: d, cm: $('[data-u="cm"]', d), ft: $('[data-u="ft"]', d), inch: $('[data-u="in"]', d), msg: $('[data-inv]', d), ftWrap: $('.vu4-dim-ft', d), cmWrap: $('.vu4-dim-cm', d) };
    });
    var read = function (id) {
      var d = dims[id], v;
      if (S.unit === 'cm') { v = d.cm.value.trim() === '' ? NaN : parseFloat(d.cm.value); }
      else {
        var f = d.ft.value.trim(), i = d.inch.value.trim();
        v = (f === '' && i === '') ? NaN : ((parseFloat(f || '0') * 12 + parseFloat(i || '0')) * 2.54);
      }
      return v;
    };
    var write = function (id, cm) {
      var d = dims[id];
      if (cm == null) { d.cm.value = ''; d.ft.value = ''; d.inch.value = ''; return; }
      d.cm.value = String(Math.round(cm));
      var f = cmToFt(cm); d.ft.value = String(f.ft); d.inch.value = String(f.inch);
    };
    var bounds = function (id) { return id === 'c' ? [CEIL_MIN, CEIL_MAX] : [def.min, def.max]; };
    var layoutUnits = function () {
      Object.keys(dims).forEach(function (id) { dims[id].cmWrap.hidden = S.unit !== 'cm'; dims[id].ftWrap.hidden = S.unit !== 'ft'; });
    };
    var draw = function () {
      var W = S.w, L = S.l, mw = MW[S.state];
      S.x = Math.max(0, Math.min(W - mw, S.x)); S.y = Math.max(0, Math.min(L - MH, S.y));
      var px = (plan.clientWidth || 340) - 16, CAP = 252;
      var scale = Math.min(px / (W + 4), CAP / (L + 4)), fs = 13 / scale, mg = fs * 2.2;
      scale = Math.min(px / (W + 4 + mg), CAP / (L + 4 + mg)); fs = 13 / scale; mg = fs * 2.2;
      var bar = Math.max(4, 6 / scale);
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('viewBox', (-mg) + ' ' + (-mg) + ' ' + (W + 4 + mg) + ' ' + (L + 4 + mg));
      svg.setAttribute('role', 'group'); svg.setAttribute('aria-label', T.planFigure);
      var dw = Math.min(80, W * 0.3), dx0 = Math.min(30, W * 0.1), dy = L;
      var deskSvg = '';
      if (el.hasAttribute('data-desk') && D.sprites) {
        var dkx = Math.max(0, W - 120), cx = Math.max(0, dkx + 35);
        deskSvg = '<g class="vu4-desk" aria-hidden="true"><image href="' + D.sprites.desk + '" x="' + dkx + '" y="0" width="120" height="60" preserveAspectRatio="none" filter="url(#vu4-ink2)"/><image href="' + D.sprites.chair + '" x="' + cx + '" y="62" width="50" height="50" preserveAspectRatio="none" filter="url(#vu4-ink2)"/></g>';
      }
      svg.innerHTML = '<defs><filter id="vu4-ink2" color-interpolation-filters="sRGB"><feComponentTransfer><feFuncA type="linear" slope="1.5" intercept="-0.08"/></feComponentTransfer></filter></defs><rect class="vu4-room" x="0" y="0" width="' + W + '" height="' + L + '"/>' + deskSvg +
        '<g class="vu4-door" aria-hidden="true"><line class="vu4-door-gap" x1="' + dx0 + '" y1="' + dy + '" x2="' + (dx0 + dw) + '" y2="' + dy + '"/><line x1="' + dx0 + '" y1="' + dy + '" x2="' + dx0 + '" y2="' + (dy - dw) + '"/><path fill="none" d="M' + (dx0 + dw) + ' ' + dy + ' A' + dw + ' ' + dw + ' 0 0 0 ' + dx0 + ' ' + (dy - dw) + '"/></g>' +
        '<text class="vu4-dimlbl" x="' + (W / 2) + '" y="' + (-fs * 0.7) + '" font-size="' + fs.toFixed(1) + '" text-anchor="middle">' + rangeTxt(W) + '</text>' +
        '<text class="vu4-dimlbl" x="' + (-fs * 0.7) + '" y="' + (L / 2) + '" font-size="' + fs.toFixed(1) + '" text-anchor="middle" transform="rotate(-90 ' + (-fs * 0.7) + ' ' + (L / 2) + ')">' + rangeTxt(L) + '</text>' +
        '<g class="vu4-drag" tabindex="0" role="application" aria-label="' + T.move.replace(/"/g, '&quot;') + '" transform="translate(' + S.x + ' ' + S.y + ')">' +
        '<rect class="vu4-gm3" x="0" y="0" width="' + mw + '" height="' + MH + '"/><rect class="vu4-tower" x="0" y="0" width="' + bar + '" height="' + MH + '"/></g>';
      plan.textContent = ''; plan.appendChild(svg);
      var g = $('.vu4-drag', svg), grab = null;
      var place = function () { g.setAttribute('transform', 'translate(' + S.x + ' ' + S.y + ')'); };
      var pt = function (e) { var m = svg.getScreenCTM(); if (!m) return { x: 0, y: 0 }; var p = svg.createSVGPoint(); p.x = e.clientX; p.y = e.clientY; return p.matrixTransform(m.inverse()); };
      g.addEventListener('pointerdown', function (e) { var p = pt(e); grab = { dx: p.x - S.x, dy: p.y - S.y }; g.setPointerCapture(e.pointerId); e.preventDefault(); });
      g.addEventListener('pointermove', function (e) {
        if (!grab) return; var p = pt(e);
        S.x = Math.max(0, Math.min(W - mw, p.x - grab.dx)); S.y = Math.max(0, Math.min(L - MH, p.y - grab.dy)); place();
      });
      var end = function () { grab = null; };
      g.addEventListener('pointerup', end); g.addEventListener('pointercancel', end);
      g.addEventListener('keydown', function (e) {
        var s = 5, dx = 0, dy = 0;
        if (e.key === 'ArrowLeft') dx = -s; else if (e.key === 'ArrowRight') dx = s; else if (e.key === 'ArrowUp') dy = -s; else if (e.key === 'ArrowDown') dy = s; else return;
        e.preventDefault(); S.x = Math.max(0, Math.min(W - mw, S.x + dx)); S.y = Math.max(0, Math.min(L - MH, S.y + dy)); place();
      });
      var area = W * L, pIn = MW.use * MH / area * 100, pFold = MW.fold * MH / area * 100;
      var f1 = function (n) { return n.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }); };
      $('[data-out="pct"]', el).textContent = fmt(T.readIn, { pctIn: f1(pIn), pctFold: f1(pFold) });
      var ce = $('[data-out="ceil"]', el);
      if (S.c) { var gap = S.c - CEIL; ce.hidden = false; ce.textContent = gap < 0 ? T.readCeilLow : fmt(T.readCeil, { gap: String(Math.round(gap)) }); } else ce.hidden = true;
      var sumEl = $('[data-out="sum"]', el);
      if (sumEl) priceSentence(sumEl, T.beside, { pctFold: f1(pFold) });
    };
    var sync = function (id) {
      var d = dims[id], v = read(id), b = bounds(id);
      if (id === 'c' && isNaN(v)) { S.c = null; d.msg.hidden = true; [d.cm, d.ft, d.inch].forEach(function (i) { i.removeAttribute('aria-invalid'); }); return true; }
      if (isNaN(v) || v < b[0] - 0.5 || v > b[1] + 0.5) {
        d.msg.hidden = false; d.msg.textContent = fmt(UI.invalid, { min: rangeTxt(b[0]), max: rangeTxt(b[1]) });
        [d.cm, d.ft, d.inch].forEach(function (i) { i.setAttribute('aria-invalid', 'true'); });
        return false;
      }
      d.msg.hidden = true; [d.cm, d.ft, d.inch].forEach(function (i) { i.removeAttribute('aria-invalid'); });
      S[id] = Math.round(v); return true;
    };
    Object.keys(dims).forEach(function (id) {
      var d = dims[id];
      [d.cm, d.ft, d.inch].forEach(function (inp) { inp.addEventListener('input', function () { if (sync(id)) draw(); }); });
    });
    $$('[data-unit]', el).forEach(function (b) {
      b.addEventListener('click', function () {
        S.unit = b.getAttribute('data-unit');
        $$('[data-unit]', el).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        Object.keys(dims).forEach(function (id) { var cm = id === 'c' ? S.c : S[id]; write(id, cm); dims[id].msg.hidden = true; });
        layoutUnits();
      });
    });
    $$('[data-state]', el).forEach(function (b) {
      b.addEventListener('click', function () {
        S.state = b.getAttribute('data-state');
        $$('[data-state]', el).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        draw();
      });
    });
    write('w', S.w); write('l', S.l); layoutUnits();
    draw();
    if (window.ResizeObserver) { var lastW = plan.clientWidth; new ResizeObserver(function () { if (Math.abs(plan.clientWidth - lastW) > 8) { lastW = plan.clientWidth; draw(); } }).observe(plan); }
  });

  /* ---------- T4 runner week planner ---------- */
  $$('[data-vu4-t4]').forEach(function (el) {
    var T = D.t4, st = JSON.parse(el.getAttribute('data-d')), icons = D.icons || {};
    var weekEl = $('[data-out="week"]', el), sessEl = $('[data-out="sessions"]', el);
    var plan = function () {
      var R = +st.runs, L = +st.long, len = +st.length;
      var A = (L + 2) % 7, B = (L + 4) % 7, before = (L + 6) % 7;
      var type = []; for (var i = 0; i < 7; i++) type.push('rest');
      type[L] = 'long'; type[A] = 'sa'; type[B] = 'sb';
      var need = R - 1, order = [];
      for (var d = 0; d < 7; d++) if (type[d] === 'rest' && d !== before) order.push(d);
      if (need > order.length) order.push(before);
      for (var k = 0; k < need && k < order.length; k++) type[order[k]] = 'run';
      return { type: type, A: A, B: B };
    };
    var img = function (k) { return icons[k] ? '<img src="' + icons[k] + '" alt="" width="24" height="24" loading="lazy">' : ''; };
    var render = function () {
      var p = plan(), len = +st.length;
      weekEl.textContent = '';
      p.type.forEach(function (t, i) {
        var li = document.createElement('li'), label = t === 'long' ? T.typeLong : t === 'run' ? T.typeRun : (t === 'sa' || t === 'sb') ? T.typeStrength : T.typeRest;
        li.className = 'vu4-day' + (t === 'sa' || t === 'sb' ? ' vu4-day--s' : '') + (t === 'long' ? ' vu4-day--l' : '');
        var icon = t === 'long' ? 'long' : t === 'run' ? 'run' : (t === 'sa' || t === 'sb') ? 'strength' : 'rest';
        li.innerHTML = '<b></b>' + img(icon) + '<span></span>';
        li.firstChild.textContent = T.long.days[i]; li.lastChild.textContent = label;
        weekEl.appendChild(li);
      });
      sessEl.textContent = '';
      [['a', T.sessionA, p.A], ['b', T.sessionB, p.B]].forEach(function (s) {
        var card = document.createElement('div'); card.className = 'vu4-sess';
        var h = document.createElement('h4'); h.textContent = s[1] + ' · ' + T.long.days[s[2]]; card.appendChild(h);
        var ul = document.createElement('ul');
        T.sessions[s[0]].forEach(function (m, idx) {
          var sets = m[1];
          if (len === 30 && idx < 2) sets = sets.replace(/^3 x/, '4 x');
          var li = document.createElement('li'), a = document.createElement('span'), b = document.createElement('span');
          a.textContent = m[0]; b.textContent = sets + ' · ' + m[2];
          li.appendChild(a); li.appendChild(b); ul.appendChild(li);
        });
        card.appendChild(ul); sessEl.appendChild(card);
      });
    };
    $$('[data-vu4-ctl]', el).forEach(function (g) { var id = g.getAttribute('data-vu4-ctl'); radios(g, function (v) { st[id] = v; render(); }); });
    render();
  });

  /* ---------- T6 spotter explainer ---------- */
  $$('[data-vu4-t6]').forEach(function (t6) {
    var large = t6.getAttribute('data-vu4-t6') === 'large';
    var line = $('.vu4-t6-line', t6), timers = [], played = false;
    var clear = function () { timers.forEach(clearTimeout); timers = []; };
    var showAll = function () { clear(); t6.classList.remove('is-anim'); t6.setAttribute('data-stage', '4'); if (line) { line.style.strokeDasharray = ''; line.style.strokeDashoffset = ''; } };
    var play = function () {
      clear(); played = true;
      t6.classList.add('is-anim'); t6.setAttribute('data-stage', '0');
      line.style.transition = 'none'; line.style.strokeDasharray = '1'; line.style.strokeDashoffset = '1';
      void line.getBoundingClientRect();
      line.style.transition = 'stroke-dashoffset 4s linear'; line.style.strokeDashoffset = '0';
      [[100, 1], [1500, 2], [2400, 3], [3600, 4]].forEach(function (a) { timers.push(setTimeout(function () { t6.setAttribute('data-stage', String(a[1])); }, a[0])); });
      timers.push(setTimeout(function () { t6.classList.remove('is-anim'); }, 4200));
    };
    if (!large || reduce) { showAll(); var rb0 = $('[data-vu4-replay]', t6); if (rb0 && reduce) rb0.hidden = true; return; }
    showAll();
    var rb = $('[data-vu4-replay]', t6); if (rb) rb.addEventListener('click', play);
    if ('IntersectionObserver' in window) {
      var io6 = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && !played) { play(); io6.disconnect(); } }); }, { threshold: 0.6 });
      io6.observe(t6);
    }
  });

  /* ---------- T7 movement finder ---------- */
  $$('[data-vu4-t7]').forEach(function (el) {
    var T = D.t7, st = JSON.parse(el.getAttribute('data-d')), out = $('[data-out="moves"]', el);
    var pos = { top: 12, mid: 44, low: 68, bottom: 92 };
    var col = function (h) {
      var y = pos[h] || 50;
      return '<svg class="vu4-mv-col" viewBox="0 0 28 60" aria-hidden="true" focusable="false"><rect class="vu4-mv-post" x="11" y="2" width="6" height="56" rx="2"/><rect class="vu4-mv-car" x="7" y="' + (y * 0.5 + 3) + '" width="14" height="6" rx="2"/></svg>';
    };
    var render = function () {
      var g = T.groups.filter(function (x) { return x.id === st.group; })[0] || T.groups[0];
      out.textContent = '';
      g.moves.forEach(function (m) {
        var d = document.createElement('div'); d.className = 'vu4-mv';
        d.innerHTML = col(m[1]) + '<div class="vu4-mv-t"><b></b><span></span></div>';
        $('b', d).textContent = m[0];
        $('span', d).textContent = T.cable + ': ' + T.heights[m[1]] + ' · ' + T.attach[m[2]];
        out.appendChild(d);
      });
    };
    $$('[data-vu4-ctl]', el).forEach(function (g) { radios(g, function (v) { st.group = v; render(); }); });
    render();
  });

  /* ---------- T8 setup stepper ---------- */
  $$('[data-vu4-t8]').forEach(function (el) {
    var steps = $$('.vu4-step', el), dots = $$('.vu4-dots i', el), of = $('[data-vu4-stepof]', el), prev = $('[data-vu4-prev]', el), next = $('[data-vu4-next]', el), i = 0;
    var go = function (n) {
      i = Math.max(0, Math.min(steps.length - 1, n));
      steps.forEach(function (s, k) { s.hidden = k !== i; });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      of.textContent = fmt(of.getAttribute('data-tpl'), { n: String(i + 1), total: String(steps.length) });
      prev.disabled = i === 0; next.disabled = i === steps.length - 1;
    };
    prev.addEventListener('click', function () { go(i - 1); });
    next.addEventListener('click', function () { go(i + 1); });
    go(0);
  });

  /* ---------- T4 week planners: beginner, Pilates, hybrid race week ---------- */
  $$('[data-vu4-wk]').forEach(function (el) {
    var W = D.wk, icons = D.icons || {}, st = JSON.parse(el.getAttribute('data-d'));
    var weekEl = $('[data-out="week"]', el), sessEl = $('[data-out="sessions"]', el), noteEl = $('[data-out="note"]', el);
    var days = W.days;
    var img = function (k) { return icons[k] ? '<img src="' + icons[k] + '" alt="" width="24" height="24" loading="lazy">' : ''; };
    var plan = function () {
      var type = []; for (var i = 0; i < 7; i++) type.push(['rest']);
      var cards = [], note = '';
      if (W.kind === 'beginner') {
        var n = +st.days, slots = n === 3 ? [[0, 'a'], [2, 'b'], [4, 'a']] : [[1, 'a'], [4, 'b']];
        var bKey = st.goal === 'move' ? 'm' : 'b';
        slots.forEach(function (sl) { type[sl[0]] = [sl[1] === 'b' ? bKey : 'a']; });
        cards = [['a', W.names.a], [bKey, W.names[bKey]]];
        note = W.note;
      } else if (W.kind === 'pilates') {
        var N = +st.sessions, pos = { 2: [1, 4], 3: [0, 2, 4], 4: [0, 2, 4, 5], 5: [0, 1, 3, 4, 5] }[N];
        var p = st.mix === 'strength' ? 1 : st.mix === 'pilates' ? N - 1 : Math.floor(N / 2);
        p = Math.max(1, Math.min(N - 1, p));
        for (var k = 0; k < N; k++) type[pos[k]] = [Math.floor((k + 1) * p / N) > Math.floor(k * p / N) ? 'p' : 's'];
        cards = [['p', W.names.p], ['s', W.names.s]];
        note = W.note;
      } else {
        var R = +st.runs, order = [0, 2, 6, 4, 1, 3];
        type[5] = ['long']; type[1] = ['sa']; type[3] = ['sb'];
        for (var j = 0; j < R - 1 && j < order.length; j++) { var d = order[j]; type[d] = type[d][0] === 'rest' ? ['run'] : [type[d][0], 'run']; }
        cards = [['a', W.names.a], ['b', W.names.b]];
        note = +st.race === 4 ? W.noteNear : W.noteFar;
      }
      return { type: type, cards: cards, note: note };
    };
    var label = function (t) { return W.types[t]; };
    var iconOf = function (t) { return ({ a: 'strength', b: 'strength', m: 'rest', s: 'strength', p: 'pilates', sa: 'strength', sb: 'strength', run: 'run', long: 'long', rest: 'rest' })[t]; };
    var render = function () {
      var p = plan();
      weekEl.textContent = '';
      p.type.forEach(function (t, i) {
        var li = document.createElement('li'), main = t[0];
        var isS = main === 'a' || main === 'b' || main === 'm' || main === 's' || main === 'p' || main === 'sa' || main === 'sb';
        li.className = 'vu4-day' + (isS ? ' vu4-day--s' : '') + (main === 'long' ? ' vu4-day--l' : '');
        li.innerHTML = '<b></b>' + img(iconOf(main)) + '<span></span>';
        li.firstChild.textContent = days[i];
        li.lastChild.textContent = t.length > 1 ? W.types.both : label(main === 'sa' || main === 'sb' ? 'sa' : main);
        weekEl.appendChild(li);
      });
      sessEl.textContent = '';
      p.cards.forEach(function (c) {
        var card = document.createElement('div'); card.className = 'vu4-sess';
        var on = []; p.type.forEach(function (t, i) { if (t.indexOf(c[0]) !== -1 || (W.kind === 'hybrid' && ((c[0] === 'a' && t.indexOf('sa') !== -1) || (c[0] === 'b' && t.indexOf('sb') !== -1)))) on.push(days[i]); });
        var h = document.createElement('h4'); h.textContent = c[1] + (on.length ? ' · ' + on.join(', ') : ''); card.appendChild(h);
        if (W.meta && W.meta[c[0]]) { var mp = document.createElement('p'); mp.className = 'vu4-sess-meta'; mp.textContent = W.meta[c[0]]; card.appendChild(mp); }
        var ul = document.createElement('ul');
        (W.sessions[c[0]] || []).forEach(function (m) {
          var li = document.createElement('li'), a = document.createElement('span'), b = document.createElement('span');
          a.textContent = m[0]; b.textContent = m[1] + ' · ' + m[2];
          li.appendChild(a); li.appendChild(b); ul.appendChild(li);
        });
        if (ul.children.length) card.appendChild(ul);
        sessEl.appendChild(card);
      });
      noteEl.textContent = p.note;
    };
    $$('[data-vu4-ctl]', el).forEach(function (g) { var id = g.getAttribute('data-vu4-ctl'); radios(g, function (v) { st[id] = v; render(); }); });
    render();
  });

  /* ---------- compare switch ---------- */
  var table = $('[data-vu4-table]');
  $$('[data-vu4-opt]').forEach(function (b) {
    b.addEventListener('click', function () {
      table.setAttribute('data-opt', b.getAttribute('data-vu4-opt'));
      $$('[data-vu4-opt]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    });
  });

  /* ---------- reviews ---------- */
  var fitReviews = function () {
    $$('.vu4-rcard').forEach(function (c) {
      var t = $('.vu4-rtext', c), b = $('[data-vu4-more]', c);
      if (!t.classList.contains('is-open')) b.hidden = !(t.scrollHeight > t.clientHeight + 2);
    });
  };
  $$('[data-vu4-more]').forEach(function (b) {
    b.textContent = UI.readMore;
    b.addEventListener('click', function () {
      var t = document.getElementById(b.getAttribute('aria-controls')), open = !t.classList.contains('is-open');
      t.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false'); b.textContent = open ? UI.readLess : UI.readMore;
    });
  });
  fitReviews(); window.addEventListener('resize', fitReviews); window.addEventListener('load', fitReviews);

  /* ---------- accordions ---------- */
  $$('.vu4-acct').forEach(function (b) {
    b.addEventListener('click', function () {
      var acc = b.closest('.vu4-acc'), open = !acc.classList.contains('is-open');
      acc.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  var more = $('[data-vu4-showmore]'), faq = $('[data-vu4-faq]');
  if (more && faq) {
    more.addEventListener('click', function () {
      var all = faq.classList.toggle('is-all');
      more.setAttribute('aria-expanded', all ? 'true' : 'false');
      more.textContent = all ? more.getAttribute('data-less') : more.getAttribute('data-more');
    });
  }
})();
